export const es = {
  units: {
    unit: "unidad",
    units: "unidades",
    of: "de",
    each: "c/u",
    total: "total",
    perUnit: "unidad",
    soldIn: "Se vende en unidades de",
    min: "Mín.",
    stockUnits: "unidades en stock",
  },
  header: {
    home: "Inicio",
    shop: "Tienda",
    industrialCatalog: "Consumo Animal",
    humanCatalog: "Consumo Humano",
    marketplace: "Marketplace",
    shopAll: "Ver todos los productos",
    about: "Nosotros",
    ourStory: "Nuestra Historia",
    services: "Servicios",
    contact: "Contacto",
    login: "Ingresar",
    signup: "Registro Comprador",
    admin: "Administrador",
    tagline: "Un destino para cada corte",
    profile: "Mi Perfil",
    myAddresses: "Mis Direcciones",
    logout: "Cerrar Sesión",
    dashboard: "Mi Panel",
    adminPanel: "Panel de Admin",
    vendorManagement: "Gestión Vendedor",
    myOrders: "Mis Pedidos",
  },
  footer: {
    tagline: "Un destino para cada corte",
    contactTitle: "Contacto",
    email: "info@meatbid.mx",
    phone: "+52 668 111 0410",
    address: "Ignacio Pérez sur #49, El Carrizal, 76030, Santiago de Querétaro, Querétaro",
    quickLinks: "Enlaces Rápidos",
    home: "Inicio",
    about: "Nosotros",
    services: "Servicios",
    contact: "Contacto",
    blog: "Blog",
    legal: "Legal",
    privacy: "Política de Privacidad",
    terms: "Términos de Uso",
    cookies: "Política de Cookies",
    social: "Síguenos",
    copyright: "© 2025 Meatbid Mexico SAPI de CV. Todos los derechos reservados.",
    description:
      "El marketplace e-commerce líder en México que conecta productores y compradores de carne, creando un mercado más eficiente donde los productores maximizan ganancias y los compradores obtienen mejores precios.",
    industrialProtocol: "PROTOCOLO_INDUSTRIAL_V1",
    premiumCuts: "Cortes Premium",
    ourFarms: "Nuestras Granjas",
    bespokeOrders: "Pedidos a Medida",
    shippingPolicy: "Política de Envíos",
    customerCare: "Atención al Cliente",
    trackOrder: "Rastrear Pedido",
    contactExpert: "Contactar a un Experto",
    returns: "Devoluciones",
    faqs: "Preguntas Frecuentes",
    subscribeTitle: "Suscríbete",
    subscribeText: "Suscríbete a nuestra lista de contactos para recibir actualizaciones y ofertas de nuestros productos y servicios.",
    emailPlaceholder: "Tu Correo Electrónico",
    joinCollection: "ÚNETE A LA COLECCIÓN",
  },
  index: {
    hero: {
      title: "Tu fuente confiable de productos cárnicos",
      subtitle:
        "Conectamos procesadores, compradores y aliados. Transformando la manera en que la industria cárnica comercializa",
      question: "¿Qué tipo de comprador eres?",
      description: "Selecciona tu categoría para explorar nuestros catálogos especializados",
      shopNow: "Comprar ahora",
    },
    industrial: {
      title: "Productos industriales",
      subtitle: "Derivados cárnicos y proteínas",
      description:
        "Materías primas para la industria de alimento para mascotas, farmacéutica y procesamiento industrial",
      features: [
        "Proteínas de alto grado",
        "Suministro a granel",
        "Especificaciones personalizadas",
      ],
      cta: "Envíanos tus requerimientos",
    },
    humanConsumption: {
      title: "Consumo humano",
      subtitle: "Cortes y productos de proteína animal",
      description: "Para restaurantes, comercios minoristas y consumidores directos",
      features: [
        "Cortes frescos premium",
        "Granjas certificadas",
        "Variedad de cortes",
        "Estándares de seguridad alimentaria",
      ],
      cta: "Envíanos tus requerimientos",
    },
    stats: {
      quality: "Calidad garantizada",
      delivery: "Entrega nacional",
      certified: "Proveedores certificados",
    },
  },
  login: {
    backHome: "Volver al inicio",
    welcome: "Bienvenido de vuelta",
    subtitle: "Inicia sesión en tu cuenta de Meatbid",
    email: "Correo electrónico",
    password: "Contraseña",
    signIn: "Iniciar sesión",
    signingIn: "Iniciando sesión...",
    noAccount: "¿No tienes cuenta?",
    signUp: "Regístrate aquí",
    or: "O",
    success: "Sesión iniciada exitosamente",
    error: "Credenciales incorrectas. Intenta de nuevo.",
    emailNotConfirmed: "Verifica tu correo electrónico antes de iniciar sesión.",
  },
  loginModal: {
    welcome: "Bienvenido",
    subtitle: "INDUSTRIAL_ACCESS_V1",
    email: "Correo Electrónico",
    password: "Contraseña",
    signIn: "INICIAR SESIÓN",
    or: "O continúa con",
    noAccount: "¿No tienes cuenta?",
    signUp: "Regístrate aquí",
    error: "El correo o la contraseña son incorrectos.",
    success: "Sesión iniciada correctamente",
    invalid: "Credenciales inválidas",
    generalError: "Error al iniciar sesión",
    emailNotConfirmed: "Verifica tu correo electrónico antes de iniciar sesión.",
  },
  buyerSignup: {
    backHome: "Volver al inicio",
    createAccount: "Crear Cuenta", // Updated to match design
    joinAs: "Únete a Meatbid como comprador",
    signupTitle: "Registro de comprador",
    heroTitle: "Elevando el\nComercio\nCárnico Global.",
    heroSubtitle: "Únete a un mercado industrial exclusivo diseñado para mayoristas, productores y distribuidores premium.",
    formSubtitle: "Solicita acceso exclusivo a nuestra plataforma premium.",
    brandName: "MeatBid",
    fullName: "Nombre completo *",
    companyName: "Nombre de la empresa *",
    phoneNumber: "Número de teléfono *",
    location: "Ubicación",
    selectState: "Selecciona tu estado",
    businessType: "Tipo de negocio",
    selectIndustry: "Selecciona tu industria",
    email: "Correo electrónico *",
    password: "Contraseña *",
    creating: "Creando cuenta...",
    createButton: "Crear Cuenta", // Updated to match design
    haveAccount: "¿Ya tienes cuenta?",
    signIn: "Iniciar Sesión", // Updated to match design
    signupSuccess: "Cuenta creada exitosamente",
    signupError: "Error al crear la cuenta. Intenta de nuevo.",
    checkEmailTitle: "Revisa tu correo",
    checkEmailDescription:
      "Enviamos un enlace de verificación a {email}. Activa tu cuenta desde ese correo antes de iniciar sesión.",
    goToLogin: "Ir a iniciar sesión",
    industries: {
      restaurant: "Restaurante",
      petfood: "Alimento para mascotas",
      processing: "Procesadora de alimentos",
      retail: "Venta al por menor",
      wholesale: "Mayorista",
      other: "Otro",
    },
  },
  catalogIndustrial: {
    title: "Consumo Animal",
    subtitle: "Productos cárnicos y derivados para uso industrial",
    search: "Buscar productos...",
    contact: "Solicitar Información",
    addToCart: "Agregar al Carrito",
    addedToCart: "Agregado al carrito",
    noResults: "No se encontraron productos",
    loading: "Cargando productos...",
    error: "Error al cargar productos del servidor",
    contactMessage: "Contactaremos para más información sobre",
  },
  catalogHumanConsumption: {
    title: "Consumo Humano",
    subtitle: "Cortes premium y productos cárnicos para consumo directo",
    search: "Buscar productos...",
    contact: "Solicitar Información",
    addToCart: "Agregar al Carrito",
    addedToCart: "Agregado al carrito",
    noResults: "No se encontraron productos",
    loading: "Cargando productos...",
    error: "Error al cargar productos del servidor",
    contactMessage: "Contactaremos para más información sobre",
  },
  productMarketplace: {
    general: {
      title: "Marketplace Meatbid",
      subtitle: "Explora nuestra selección premium de productos cárnicos",
    },
    industrial: {
      title: "Consumo Animal",
      subtitle: "Productos cárnicos y derivados para uso industrial",
    },
    human_consumption: {
      title: "Consumo Humano",
      subtitle: "Cortes premium y productos cárnicos para consumo directo",
    },
  },
  productDetail: {
    back: "Volver al catálogo",
    contact: "Solicitar Información",
    addToCart: "Agregar al Carrito",
    addedToCart: "Agregado al carrito",
    description: "Descripción",
    specifications: "Especificaciones Técnicas",
    downloadSpec: "Descargar Ficha Técnica",
    price: "Precio",
    weight: "Peso Aproximado",
    stock: "Disponibilidad",
    inStock: "En existencia",
    outOfStock: "Agotado",
    vendor: "Vendedor",
    category: "Categoría",
    loading: "Cargando detalles del producto...",
    error: "Error al cargar el producto",
    notFound: "Producto no encontrado",
    details: "Detalles del producto",
    contactMessage: "Contactaremos para más información sobre",
    loginRequired: "Inicia sesión para solicitar información de este producto.",
    inquiryTitle: "Consulta de producto",
    inquiryDescription: "Cuéntanos qué necesitas y un ejecutivo dará seguimiento con la información del producto.",
    inquiryPhone: "Teléfono",
    inquiryPhonePlaceholder: "+52 (555) 555-5555",
    inquiryMessage: "Mensaje",
    inquiryPlaceholder: "Hola, me interesa este producto. Quisiera conocer disponibilidad, volumen mínimo y tiempos de entrega.",
    inquiryCancel: "Cancelar",
    inquirySend: "Enviar consulta",
    inquirySuccess: "Consulta enviada. Te contactaremos pronto.",
    inquiryError: "No pudimos enviar la consulta. Intenta de nuevo.",
    inquiryRateLimit: "Demasiadas solicitudes. Intenta más tarde.",
    inquiryPhoneError: "Ingresa un teléfono válido.",
    inquiryMessageError: "El mensaje debe tener al menos 10 caracteres.",
    basePrice: "precio base",
    ivaLabel: "+ 16% IVA",
    units: "unidades",
    noDescription: "Sin descripción disponible.",
  },
  common: {
    kg: "kg",
    items: "artículos",
    itemsCount: "{count} ARTÍCULOS",
    dateFormat: "dd MMM, yyyy",
    shortDateFormat: "dd MMM",
    weight: "{weight} KG",
    loading: "Cargando...",
    more: "Más",
    morePages: "Más páginas",
    next: "Siguiente",
    previous: "Anterior",
    close: "Cerrar",
    menu: "Menú",
    total: "Total",
    price: "Precio",
    quantity: "Cantidad",
    status: "Estado",
    date: "Fecha",
    email: "Email",
    phone: "Teléfono",
    company: "Empresa",
    address: "Dirección",
    city: "Ciudad",
    notes: "Notas",
    actions: "Acciones",
    customer: "Cliente",
    logisticsProgress: "PROGRESO LOGÍSTICO",
    unexpectedError: "Ocurrió un error inesperado. Hemos sido notificados.",
    all: "Todos",
    processing: "PROCESANDO...",
    newProduct: "Nuevo Producto",
    newOrder: "Nuevo Pedido",
    addProduct: "Agregar Producto",
  },
  auth: {
    toggleTheme: "Cambiar tema",
    userMenu: "Menú de usuario",
    meatbidLogo: "MEATBID",
    alreadyHaveAccount: "¿Ya tienes una cuenta?",
  },
  checkout: {
    title: "Finalizar Compra",
    subtitle: "REVISIÓN Y PAGO SEGURO",
    shipping: "INFORMACIÓN DE ENVÍO",
    summary: "RESUMEN DEL PEDIDO",
    subtotal: "SUBTOTAL",
    iva: "IVA (16%)",
    total: "TOTAL A PAGAR",
    placeOrder: "CONFIRMAR PEDIDO",
    back: "Volver al catálogo",
    savedAddresses: "Direcciones Guardadas",
    newAddress: "Nueva Dirección",
    receiver: "Nombre del Recipiente",
    phone: "Teléfono",
    saveForFuture: "Guardar esta dirección para futuras compras",
    processing: "PROCESANDO...",
    paymentMethod: "MÉTODO DE PAGO",
    payNow: "Pagar Ahora",
    payLater: "Confirmar Pedido y Pagar Después",
    payLaterDesc: "Un ejecutivo se pondrá en contacto para coordinar el pago (Transferencia/Efectivo).",
    securePayment: "Pago Seguro con Conekta",
    paymentAcknowledge: "Pago vía Conekta",
    paymentDesc: "Tarjetas, SPEI y OXXO Pay",
    forNow: "SEGURO",
    items: "ARTÍCULOS",
    reviewShipping: "Revisar Envío",
    shippingTo: "Enviando a",
    orderSummary: "Resumen del Pedido",
    totalAmount: "Monto Total",
    paymentInProgress: "Pago en Progreso",
    paymentInstructions: "POR FAVOR COMPLETE SU TRANSACCIÓN EN EL ÁREA SEGURA. NO CIERRE NI REFRESQUE ESTA VENTANA.",
    cancelRestart: "CANCELAR Y CONTINUAR COMPRANDO",
    orderSuccess: "Pedido realizado exitosamente",
    orderError: "Error al procesar el pedido",
    emptyCart: "Carrito Vacío",
    goToCatalog: "IR AL CATÁLOGO",
    support: "SOPORTE",
    supportDesc:
      "AL CONFIRMAR EL PEDIDO, UN AGENTE SE COMUNICARÁ PARA COORDINAR LA LOGÍSTICA DE ENTREGA.",
    fulfillment: "TIPO DE ENTREGA",
    fulfillmentSubtitle: "Elige cómo quieres recibir cada artículo",
    delivery: "Envío a domicilio",
    pickup: "Recoger en almacén",
    selectWarehouse: "Seleccionar almacén...",
    pickupAvailableBadge: "Disponible",
    pickupNotifyBadge: "Aviso",
    pickupAvailableNow: "{count} unidades disponibles ahora en este almacén.",
    pickupPartialLive:
      "Solo hay {count} unidades disponibles ahora. Puedes seleccionar este almacén y te avisaremos cuando llegue el resto.",
    pickupNotifyWhenAvailable:
      "No hay inventario en vivo en este almacén. Puedes seleccionarlo y te avisaremos cuando haya inventario disponible.",
  },
  adminDashboard: {
    title: "Panel de Administración",
    providers: "Proveedores",
    categories: "Categorías",
    warehouses: "Almacenes",
    users: "Usuarios",
    settings: "Ajustes",
    overview: "Resumen",
    overviewComingSoon: "Próximamente: Panel de control global y métricas",
    usersComingSoon: "Próximamente: Gestión global de usuarios",
    settingsComingSoon: "Próximamente: Configuración del sistema",
    quickAddSupplier: "Registro rápido: Compra a Proveedor",
    quickAddClient: "Registro rápido: Pedido de Cliente",
    supplierOrders: "Compras a Proveedores",
    clientOrders: "Pedidos de Clientes",
    order: "Orden",
    meatType: "Tipo de Carne",
    pricePerKg: "Precio por kg",
    received: "Recibido",
    delivered: "Entregado",
    paid: "Pagado",
    actions: "Acciones",
  },
  warehouseManagement: {
    title: "Almacenes",
    subtitle: "GESTIÓN DE UBICACIONES DE INVENTARIO",
    newWarehouse: "Nuevo Almacén",
    editWarehouse: "Editar Almacén",
    nameLabel: "Nombre del Almacén",
    namePlaceholder: "Ej. Almacén Central Norte",
    addressLabel: "Dirección FÍSICA",
    cancel: "Cancelar",
    save: "Guardar Almacén",
    nameCol: "Nombre",
    locationCol: "Ubicación",
    actionsCol: "Acciones",
    loading: "CARGANDO...",
    empty: "NO HAY ALMACENES REGISTRADOS",
    deleteConfirm: "¿Estás seguro de eliminar este almacén? Esta acción no se puede deshacer.",
    successCreate: "Almacén creado exitosamente",
    successUpdate: "Almacén actualizado exitosamente",
    successDelete: "Almacén eliminado exitosamente",
    errorCreate: "Error al crear el almacén",
    errorUpdate: "Error al actualizar el almacén",
    errorDelete: "No se pudo eliminar el almacén. Puede que tenga inventario asignado.",
  },
  orderTracking: {
    last30Days: "Últimos 30 días",
    last3Months: "Últimos 3 meses",
    progress: "Progreso",
    orderTotal: "Total del pedido",
    shippingDelivery: "Envío y entrega",
    paymentMethod: "Método de pago",
    product: "Producto",
    sku: "SKU",
    unitPrice: "Precio unit.",
    executiveConvenience: "Convenio con ejecutivo MeatBid",
    estimatedDelivery: "Entrega estimada: próximamente",
    contactExecutive: "Contactar ejecutivo",
    downloadInvoice: "Descargar factura",
    trackShipment: "Rastrear envío",
    reorder: "Reordenar",
    itemsCount: "{count} artículos",
    productSubtotal: "Productos",
    shippingCost: "Costo de envío",
    total: "Total",
    reference: "REF",
    paymentRequired: "Pago requerido - REF {ref}",
    payAmount: "Pagar ${amount}",
    paymentProcessing: "Procesando pago",
    pickupShipment: "Recogida en almacén",
    pickupBadge: "Pickup",
    warehouseFallback: "Almacén #{id}",
    notAvailable: "N/D",
    deliveredAt: "Entregado el {date}",
    reorderAdded: "{count} producto(s) agregado(s) al carrito",
    reorderUnavailable: "No se pudo reordenar este pedido",
    reorderUnavailableDescription: "El pedido no incluye suficiente información de producto para agregarlo al carrito.",
    invoiceComingSoon: "La descarga de factura estará disponible próximamente.",
    shipmentTrackingComingSoon: "El rastreo de envío estará disponible próximamente.",
    paymentLinkUnavailable: "No se pudo obtener el enlace de pago",
    paymentStartError: "Error al iniciar el pago. Intenta de nuevo.",
    paymentSystemLoadError: "No se pudo cargar el sistema de pago.",
  },
  aboutUs: {
    title: "Sobre nosotros",
    subtitle: "TRANSFORMANDO LA INDUSTRIA CÁRNICA",
    mission: "Nuestro propósito",
    missionText:
      "Transformar la forma en que el mundo comercializa la carne. En Meatbid conectamos procesadores, compradores y aliados a través de tecnología que simplifica las transacciones, mejora el acceso y permite tomar decisiones más inteligentes.",
    vision: "Nuestra visión",
    visionText:
      "Ser la infraestructura más confiable que conecta a los productores y compradores de proteína animal, ayudando a que la industria se mueva de forma más inteligente, rápida y con total transparencia.",
    values: "Nuestros valores",
    efficiency: "Comercializar con integridad",
    efficiencyDesc:
      "Nos comprometemos a hacer lo correcto. Apostamos por la confiabilidad, la calidad, la seguridad y la transparencia en cada transacción.",
    accessibility: "Avanzar con sostenibilidad",
    accessibilityDesc:
      "Ayudamos a la industria cárnica a administrar responsablemente los recursos limitados, sentando las bases para un crecimiento sostenible.",
    innovation: "Innovar con propósito",
    innovationDesc:
      "Usamos tecnología y creatividad para aportar eficiencia, simplicidad y valor a largo plazo a la industria.",
    experience: "Años de experiencia",
    processors: "Procesadores Conectados",
    transparency: "Transparencia Total",
    readyToModernize: "¿LISTO PARA MODERNIZAR TU OPERACIÓN?",
    joinLeadingMarketplace: "ÚNETE AL MARKETPLACE LÍDER DE MÉXICO",
    contactUs: "CONTÁCTANOS",
  },
  services: {
    heading: "¿Qué hacemos?",
    title: "Servicios Para Compradores",
    subtitle: "CONECTANDO LA INDUSTRIA CÁRNICA CON TECNOLOGÍA",
    desc: "Conectamos procesadores, compradores y aliados a través de tecnología que simplifica las transacciones y mejora el acceso a productos cárnicos.",
    catalogTitle: "Catálogos Especializados",
    industrialCat: "Consumo Animal",
    humanCat: "Consumo Humano",
    buyerBenefits: "Beneficios para Compradores",
    directAccess: "Suministro de productos",
    directAccessDesc:
      "Explore nuestros catálogos especializados con productos de alta calidad y certificaciones garantizadas.",
    variety: "Acceso a red global",
    varietyDesc: "Conéctese con una amplia red de procesadores y compradores en todo México.",
    convenience: "Modelos duraderos",
    convenienceDesc: "Construya relaciones comerciales sólidas y sostenibles a largo plazo.",
    quality: "Logística Industrial",
    qualityDesc: "Gestión integral de logística y distribución para sus productos cárnicos.",
    support: "E-commerce Estratégico",
    supportDesc:
      "Digitaliza tus ventas y compras con un marketplace que simplifica tus transacciones.",
    ctaHeadline: "Potenciando la industria cárnica a través de la conectividad estratégica",
    partnerWithUs: "ASÓCIATE",
    contactSales: "CONTACTA A VENTAS",
    viewCatalog: "VER CATÁLOGO",
    coreServices: "SERVICIOS PRINCIPALES",
  },
  contact: {
    title: "Contáctanos",
    subtitle: "ESTAMOS AQUÍ PARA AYUDARTE",
    getInTouch: "Ponte en contacto",
    name: "Nombre completo",
    email: "Correo electrónico",
    subject: "Asunto",
    message: "Mensaje",
    send: "Enviar mensaje",
    sending: "Enviando...",
    contactInfo: "Información de contacto",
    address: "Dirección",
    addressText: "Ignacio Pérez sur #49, El Carrizal, 76030, Santiago de Querétaro, Querétaro",
    phone: "Teléfono",
    emailAddress: "Email",
    emailText: "info@meatbid.mx",
    hours: "Horario de atención",
    hoursText: "Lunes a Viernes: 9:00 AM - 6:00 PM",
    successMessage: "¡Mensaje enviado exitosamente! Te contactaremos pronto.",
    messagePlaceholder: "Escriba su mensaje aquí...",
    tooManyRequests: "Demasiadas solicitudes. Por favor intente más tarde.",
    errorMessage: "Error al enviar el mensaje. Por favor intente de nuevo.",
    interactiveMap: "MAPA INTERACTIVO",
    processing: "Procesando...",
    subjects: {
      general: "Consulta general",
      seller: "Información para vendedores",
      buyer: "Información para compradores",
      partnership: "Oportunidades de asociación",
      support: "Soporte técnico",
    },
  },
  requirements: {
    title: "Solicitud de Requerimientos",
    subtitle: "Dinos qué necesitas y te ayudaremos a encontrarlo",
    description:
      "Si no encuentras el producto exacto en nuestro catálogo, completa este formulario con tus especificaciones técnicas, volúmenes y frecuencia de compra.",
    form: {
      name: "Nombre completo",
      email: "Correo electrónico",
      company: "Empresa",
      requirements: "Especificaciones del requerimiento",
      placeholder: "Ej: Necesito 5 toneladas mensuales de pulpa negra de res, corte americano...",
      submit: "Enviar requerimiento",
      sending: "Enviando...",
    },
    benefits: {
      title: "¿Por qué enviar tu requerimiento?",
      items: [
        "Acceso a red global de proveedores verificados",
        "Cotizaciones personalizadas en menos de 48h",
        "Logística y aseguramiento de calidad incluido",
        "Ahorros por volumen y consolidación",
      ],
    },
    success: {
      title: "¡Requerimiento recibido!",
      message:
        "Hemos recibido tus especificaciones. Un asesor de MeatBid se pondrá en contacto contigo a la brevedad.",
    },
    error: "Error al enviar el requerimiento",
  },
  order: {
    title: "Mis Pedidos",
    subtitle: "ESTADO Y SEGUIMIENTO DE COMPRAS",
    loading: "Cargando tus pedidos...",
    empty: "Aún no has realizado ningún pedido.",
    notFound: "No se encontraron pedidos",
    searchPlaceholder: "buscar pedidos...",
    orderId: "PEDIDO",
    date: "FECHA",
    status: "ESTADO",
    items: "ARTÍCULOS",
    shipping: "DIRECCIÓN DE ENVÍO",
    payment: "PAGO",
    total: "TOTAL DEL PEDIDO",
    subtotal: "SUBTOTAL",
    iva: "IVA (16%)",
    receiver: "Recibe",
    address: "Dirección",
    details: "DETALLES DEL ENVÍO",
    totalOrders: "TOTAL ÓRDENES",
    shipments: "ENVÍOS",
    originShipment: "ENVÍO DE ORIGEN",
    paymentInfo: "INFO DE PAGO",
    paymentInstructions: "PAGO A CONVENIR CON UN EJECUTIVO DE MEATBID",
    pipelineProgress: "PROGRESO LOGÍSTICO",
    financials: "FINANZAS",
    shipmentBreakdown: "DESGLOSE DETALLADO DE ENVÍOS ({count} ENVÍOS)",
    shippingTitle: "ENVÍO Y ENTREGA",
    paymentTitle: "INSTRUCCIONES DE PAGO",
    statuses: {
      Pending: "PENDIENTE",
      StockVerified: "VERIFICADO",
      ShippingQuoted: "COTIZADO",
      PaymentReceived: "PAGADO",
      OrderDeclined: "RECHAZADO",
      OrderShipped: "EN CAMINO",
      ReadyForPickup: "LISTO P/ RECOGER",
      OrderComplete: "ENTREGADO",
    } as Record<string, string>,
  },
  savedAddresses: {
    title: "Mis Direcciones",
    subtitle: "Gestiona tus direcciones de envío para una compra más rápida",
    addAddress: "Agregar Nueva Dirección",
    editAddress: "Editar Dirección",
    deleteConfirm: "¿Estás seguro de eliminar esta dirección?",
    setDefault: "Establecer como predeterminada",
    default: "Predeterminada",
    receiver: "Nombre del Recipiente",
    phone: "Teléfono",
    street: "Calle",
    extNum: "Num Exterior",
    intNum: "Num Interior (Opcional)",
    neighborhood: "Colonia",
    city: "Ciudad/Municipio",
    state: "Estado",
    zipCode: "Código Postal",
    save: "Guardar Cambios",
    cancel: "Cancelar",
    loading: "Cargando direcciones...",
    noAddresses: "No tienes direcciones guardadas.",
    successAdd: "Dirección agregada con éxito",
    successEdit: "Dirección actualizada con éxito",
    successDelete: "Dirección eliminada con éxito",
    successDefault: "Dirección predeterminada actualizada",
    back: "Volver",
    validationError: "Por favor revisa los errores en el formulario.",
    edit: "Editar",
    autoFilled: "Automático",
    autoFilledHint: "Se completan automáticamente con el código postal",
    cpLoading: "Buscando código postal...",
    cpNotFound: "Código postal no encontrado",
    selectColonia: "Selecciona una colonia",
    coloniaNeedsCp: "Ingresa un código postal válido",
    statePlaceholder: "Se completa con el C.P.",
    cityPlaceholder: "Se completa con el C.P.",
  },
  heroSection: {
    tagline: "Un destino para cada corte",
    question: "¿Eres Comprador o Vendedor?",
    buyer: "Comprador",
    seller: "Vendedor",
    subtitle: "MeatBid: Tu Puerta de Entrada al Mercado de Carne de México",
    description:
      "La plataforma e-commerce líder que conecta productores y compradores de carne en México. Descubre cortes premium directamente de distribuidores independientes, automatiza tus ventas y accede a una red nacional de clientes verificados. Experimenta el comercio de carne simplificado con precios competitivos en tiempo real.",
    cta: "Únete al ecosistema de comercio de carne más eficiente de México",
    joinButton: "Comenzar Ahora",
    stats: {
      waste: "500,000",
      wasteLabel: "Toneladas de carne desperdiciadas solo en México por mercados ineficientes",
      market: "8.7M",
      marketLabel: "Cabezas de ganado producidas anualmente en México (pronóstico 2025)",
      efficiency: "$60.67B USD",
      efficiencyLabel: "Ingresos del mercado de carne en México (pronóstico 2025)",
    },
    benefits: {
      title: "¿Por qué elegir MeatBid?",
      marketplace: "Marketplace Especializado",
      marketplaceDesc:
        "Plataforma e-commerce diseñada específicamente para la industria cárnica mexicana con funcionalidades adaptadas a productores y compradores",
      ecommerce: "Entrada Fácil al E-commerce",
      ecommerceDesc:
        "La forma más fácil y económica para vendedores de carne de ingresar al mercado de comercio electrónico de manera eficiente",
      national: "Conexión Nacional",
      nationalDesc:
        "Conecta compradores y vendedores a nivel nacional, eliminando barreras geográficas y expandiendo oportunidades de negocio",
      efficiency: "Eficiencia Total",
      efficiencyDesc:
        "Automatiza tus procesos de venta, expande tu alcance a nivel nacional y conecta con miles de compradores verificados sin esfuerzo",
      accessibility: "Acceso Directo",
      accessibilityDesc:
        "Los compradores acceden directamente a distribuidores independientes, obteniendo mejores precios y mayor variedad de cortes premium",
      security: "Transacciones Seguras",
      securityDesc:
        "Plataforma segura con verificación de usuarios, pagos protegidos y garantía de calidad para todas las transacciones",
    },
  },
  cartSheet: {
    title: "Carrito de Compras",
    empty: "Tu carrito está vacío",
    subtotal: "Subtotal",
    checkout: "Proceder al Pago",
    clear: "Limpiar Carrito",
    items: "artículos",
    unit: "unidad",
    continueShopping: "Continuar Comprando",
  },
  vendorDashboard: {
    title: "Mi Panel de Vendedor",
    welcome: "Bienvenido de nuevo, ",
    subtitle: "Administra tu inventario, rastrea pedidos y monitorea tu desempeño de ventas.",
    settings: "Configuración",
    tabs: {
      inventory: "Mi Inventario",
      addProduct: "Agregar Producto",
      orders: "Pedidos Pendientes",
      history: "Historial de Ventas",
    },
    stats: {
      totalSales: "Ventas Totales",
      activeProducts: "Productos Activos",
      pendingOrders: "Pedidos Pendientes",
      noInventoryFound: "No se encontro inventario",
      sub: {
        sales: "ÚLTIMOS 30 DÍAS",
        products: "EN CATÁLOGO",
        pending: "REQUIEREN ACCIÓN",
      },
    },
    performance: "Rendimiento",
    mainMenu: "MENÚ PRINCIPAL",
  },
  categoryManagement: {
    title: "Gestión de Categorías",
    subtitle: "Administra la jerarquía global de productos",
    add: "Nueva Categoría",
    edit: "Editar Categoría",
    nameEs: "Nombre (Español)",
    nameEn: "Nombre (Inglés)",
    parent: "Categoría Padre",
    none: "Ninguna (Raíz)",
    save: "Guardar Cambios",
    cancel: "Cancelar",
    empty: "No hay categorías",
    actions: "Acciones",
    deleteConfirm: "¿Eliminar categoría?",
    successCreate: "Categoría creada",
    successUpdate: "Categoría actualizada",
    successDelete: "Categoría eliminada",
    errorDelete: "Error al eliminar: ",
    loading: "Cargando...",
    categoryLabel: "Categoría (ES / EN)",
  },
  providerManagement: {
    title: "Administración de Proveedores",
    subtitle: "Gestiona las marcas y orígenes globales para los productos",
    add: "Agregar Proveedor",
    edit: "Editar Proveedor",
    delete: "Eliminar",
    name: "Nombre",
    description: "Descripción",
    logoUrl: "URL del Logo",
    actions: "Acciones",
    save: "Guardar Cambios",
    cancel: "Cancelar",
    empty: "No hay proveedores registrados",
    successCreate: "Proveedor creado",
    successUpdate: "Proveedor actualizado",
    successDelete: "Proveedor eliminado",
    deleteConfirm: "¿Eliminar este proveedor?",
    loading: "Cargando...",
  },
  productCatalog: {
    search: "Buscar productos por nombre o descripción...",
    contact: "Solicitar Información",
    addToCart: "Agregar al Carrito",
    add: "Agregar",
    addedToCart: "añadido al carrito",
    noResults: "No se encontraron productos",
    noPageResults: "No hay productos en esta página",
    loading: "Cargando catálogo...",
    error: "Error al conectar con el servidor",
    allCategories: "Ver Todo",
    categories: "Categorías",
    providers: "Proveedores",
    allProviders: "Todos los proveedores",
    price: "Precio",
    priceRange: "Rango de Precio",
    weightRange: "Rango de Peso",
    min: "Min",
    max: "Max",
    incVat: "con IVA",
    sort: {
      label: "Ordenar por",
      name_asc: "Nombre (A-Z)",
      price_asc: "Precio: Menor a Mayor",
      price_desc: "Precio: Mayor a Menor",
      newest: "Novedades",
    },
    pagination: {
      label: "Páginas del catálogo",
      previous: "Anterior",
      next: "Siguiente",
      page: "Página",
      perPage: "Por página",
      showing: "Mostrando",
      goToPage: "Ir a página",
    },
    contactInfo: "Contactaremos para más información sobre",
  },
  productForm: {
    title: "Publicar Nuevo Producto",
    editTitle: "Editar Producto",
    name: "Nombre del Producto",
    sku: "SKU / Código Único",
    description: "Descripción",
    price: "Precio de Venta ($)",
    unitCost: "Costo Unitario ($)",
    weight: "Peso",
    unit: "Unidad",
    images: "Imágenes del Producto",
    techSpec: "Ficha Técnica (PDF)",
    uploadImages: "Subir Imágenes",
    uploadSpec: "Subir Ficha Técnica",
    stock: "Stock Inicial",
    lowStock: "Umbral de Stock Bajo",
    leadTime: "Tiempo de Entrega (Días)",
    safetyStock: "Stock de Seguridad",
    taxable: "Gravable (IVA 16%)",
    totalPrice: "Precio Total (con IVA)",
    category: "Categoría",
    provider: "Proveedor / Marca",
    selectProvider: "Seleccionar proveedor...",
    selectCategory: "Seleccionar categoría...",
    newCategory: "Nueva categoría",
    consumptionType: "Tipo de Consumo",
    consumptionHuman: "Consumo Humano",
    consumptionIndustrial: "Consumo Animal",
    originWarehouse: "Almacén de origen",
    selectWarehouse: "Selecciona un almacén",
    cancel: "Cancelar",
    create: "Crear",
    submit: "Publicar Producto",
    save: "Guardar Cambios",
    success: "Producto publicado correctamente",
    successUpdate: "Producto actualizado correctamente",
    selectPrimary: "Selecciona la imagen principal",
    validationError: "Por favor revisa los errores en el formulario.",
    currentImages: "Imágenes Actuales",
    currentTechSpec: "Ficha Técnica Actual",
    viewDocument: "Ver Documento",
    industrialProtocol: "PROTOCOLO_INDUSTRIAL_V1",
    namePlaceholder: "ej. Ribeye Premium Angus",
    skuPlaceholder: "ej. BEEF-RIB-001",
    descPlaceholder: "Describe el corte, origen, características y cualquier detalle relevante para el comprador...",
    section1Title: "INFORMACIÓN BÁSICA",
    section2Title: "PRECIOS E INVENTARIO",
    pricesLabel: "PRECIOS",
    unitCostDesc: "Costo de adquisición por unidad de venta.",
    priceDesc: "Precio al que se publicará en tienda.",
    taxableLabel: "GRAVABLE — IVA 16%",
    taxableDesc: "Se añadirá al precio de venta",
    totalPriceIncVat: "PRECIO TOTAL CON IVA",
    inventoryLogisticsLabel: "INVENTARIO Y LOGÍSTICA",
    lowStockDesc: "Alerta cuando baje de este nivel.",
    safetyStockDesc: "Reserva mínima operativa.",
    salesUnitLabel: "UNIDAD DE VENTA *",
    saleUnitKg: "KG — Kilogramo",
    saleUnitLb: "LB — Libra",
    saleUnitG: "G — Gramo",
    weightPerUnitLabel: "PESO POR UNIDAD",
  },
  vendorInventory: {
    loading: "Cargando inventario...",
    empty: "No tienes productos publicados",
    price: "PRECIO VENTA",
    stock: "DISPONIBILIDAD",
    sku: "SKU",
    financials: "MÉTRICAS",
    actions: "ACCIONES",
    deleteConfirm: "¿Eliminar producto?",
    deleteSuccess: "Producto eliminado",
    edit: "Editar",
    delete: "Borrar",
    deleting: "Borrando...",
    manageBatches: "GESTIONAR LOTES",
    view: "Vista:",
    margin: "MARGEN",
    unitCost: "COSTO UNIT",
    views: { comfortable: "Cómoda", dense: "Densa" },
    filters: { all: "Todos", low: "Stock Bajo", out: "Agotados" },
  },
  vendorPerformance: {
    title: "Rendimiento del Vendedor",
    revenueTrend: "Tendencia de Ingresos",
    topProducts: "Productos Más Vendidos",
    inventoryHealth: "Salud del Inventario",
    totalRevenue: "Ingresos Totales",
    totalOrders: "Pedidos Completados",
    inventoryTurnover: "Rotación de Inventario",
    inventoryToSales: "Inventario vs Ventas",
    outOfStock: "Sin Stock",
    lowStock: "Stock Bajo",
    healthy: "En Buen Estado",
    healthyStock: "Inventario saludable",
    restockTitle: "Recomendaciones de Resurtido",
    restockDesc: "Productos por debajo del punto de reorden",
    days: {
      7: "Últimos 7 días",
      30: "Últimos 30 días",
      90: "Últimos 90 días",
    },
    empty: "No hay datos suficientes para mostrar estadísticas.",
    revenue: "Ingresos",
    quantity: "Cantidad",
    product: "Producto",
    loading: "Cargando analíticas...",
    completedShipments: "Envíos completados",
    efficiencyRatio: "Ratio de eficiencia",
    capitalTieUp: "Capital inmovilizado",
    urgentRestock: "Resurtido urgente",
    belowThreshold: "Artículos bajo el umbral",
    byQuantity: "Por cantidad vendida",
  },
  vendorOrders: {
    title: "Gestión de Pedidos",
    queue: "COLA: {active} DE {pending}",
    refId: "REF ID:",
    client: "CLIENTE",
    shippingAddress: "DIRECCIÓN DE ENVÍO",
    actionsRequired: "ACCIONES REQUERIDAS",
    noActions: "No se requieren más acciones",
    orderRejected: "El pedido fue rechazado",
    viewAuditLog: "Ver Bitácora Completa",
    validateStock: "VALIDAR STOCK",
    rejectOrder: "RECHAZAR PEDIDO",
    paymentCleared: "PAGO LIQUIDADO",
    approveRelease: "APROBAR Y LIBERAR",
    confirmDelivery: "CONFIRMAR ENTREGA",
    skuBreakdown: "DESGLOSE DETALLADO DE SKUs ({count} ARTÍCULOS)",
    unitQuote: "COTIZACIÓN UNITARIA",
    margin: "MARGEN",
    totalAmount: "MONTO TOTAL",
    product: "Producto",
    sku: "SKU",
    quantity: "Cantidad",
    empty: "No tienes pedidos activos",
    loading: "Cargando tu panel de operaciones...",
    orderLabel: "REF DE PEDIDO",
    dateLabel: "CREADO",
    subId: "Subpedido ID:",
    financials: "FINANZAS",
    cost: "Costo Unitario",
    productCost: "Productos",
    tax: "IVA",
    shippingCost: "Costo de envío",
    auditHistory: {
      title: "Historial de Auditoría",
      description: "Eventos de estado y pago registrados para este subpedido.",
      loading: "Cargando historial de auditoría...",
      empty: "Aún no hay eventos de auditoría registrados.",
      error: "No se pudo cargar el historial de auditoría.",
      actor: "Actor",
      actorUser: "Usuario",
      source: "Origen",
      requested: "Solicitado",
      shipping: "Envío",
      payment: "Pago",
      notAvailable: "N/D",
      actorTypes: {
        Buyer: "Comprador",
        Vendor: "Vendedor",
        Webhook: "Webhook de pago",
      },
      sources: {
        OrderFactory: "Creación de pedido",
        VendorApi: "Panel de vendedor",
        ConektaWebhook: "Webhook de Conekta",
      },
      reasons: {
        "Sub-order created": "Subpedido creado",
        "Vendor requested status transition": "El vendedor solicitó cambio de estado",
        "Vendor quoted shipping": "El vendedor cotizó el envío",
        "Payment marked paid": "Pago marcado como liquidado",
      },
    },
    total: "Monto Total",
    status: "Estado Logístico",
    address: "Envío Requerido",
    updateSuccess: "Etapa logística avanzada correctamente",
    updateError: "Error al asignar etapa",
    paidBadge: "PAGADO",
    statuses: {
      Pending: "Pendiente de Aprobación",
      StockVerified: "Inventario Validado",
      ShippingQuoted: "Envío Cotizado",
      PaymentReceived: "Pago Recibido",
      OrderShipped: "En Tránsito",
      ReadyForPickup: "Listo para Recoger",
      OrderComplete: "Completado / Entregado",
      OrderDeclined: "Rechazado / Terminado",
    },
    // New pipeline UI elements
    pipeline: "PROGRESO LOGÍSTICO",
    queueTitle: "Control Logístico",
    queueSubtitle: "Valida existencias y aprueba etapas logísticas para pedidos mayoristas.",
    queueMetrics: "Cola Logística: {active} revisiones activas de {pending} pendientes",
    actions: {
      validateStock: "VALIDAR INVENTARIO",
      shipOrder: "APROBAR Y ENVIAR",
      markComplete: "CONFIRMAR ENTREGA",
      rejectOrder: "RECHAZAR PEDIDO",
      quoteShipping: "COTIZAR ENVÍO",
      markReadyForPickup: "LISTO PARA RECOGER",
      confirmPickup: "CONFIRMAR RECOGIDA",
      awaitingPayment: "ESPERANDO PAGO DEL COMPRADOR",
      shippingCostLabel: "Costo de envío (MXN)",
    },
    supplierTitle: "Seguimiento de Compras a Proveedores",
    supplierComingSoon: "Módulo de seguimiento a proveedores próximamente.",
  },
  batchManagement: {
    title: "Gestión de Lotes - ",
    add: "Nuevo Lote",
    batchNo: "Núm. Lote",
    qty: "Cantidad",
    exp: "Caducidad",
    cost: "Costo Unit.",
    save: "Crear Lote",
    empty: "No hay lotes registrados",
    active: "Lotes Activos",
    history: "Historial",
    success: "Lote creado",
    outOfStock: "Agotado",
    creating: "CREANDO...",
    warehouse: "Almacén",
    noWarehouse: "Sin almacén asignado",
  },
  signup: {
    backHome: "Volver al inicio",
    welcome: "Únete a Meatbid",
    subtitle: "Crea una cuenta para comenzar a comercializar carne",
    email: "Correo electrónico",
    displayName: "Nombre completo",
    password: "Contraseña",
    signUp: "Registrarse",
    signingUp: "Creando cuenta...",
    haveAccount: "¿Ya tienes cuenta?",
    signIn: "Inicia sesión",
    success: "¡Cuenta creada!",
    error: "Error al crear la cuenta",
    checkEmailTitle: "Revisa tu correo",
    checkEmailDescription:
      "Enviamos un enlace de verificación a {email}. Activa tu cuenta desde ese correo antes de iniciar sesión.",
    goToLogin: "Ir a iniciar sesión",
  },
  loginSeller: {
    backHome: "Volver al inicio",
    welcome: "Bienvenido de vuelta, Vendedor",
    subtitle: "Inicia sesión en tu cuenta de vendedor Meatbid",
    email: "Correo electrónico",
    password: "Contraseña",
    signIn: "Iniciar sesión",
    signingIn: "Iniciando sesión...",
    noAccount: "¿No tienes cuenta de vendedor?",
    signUp: "Regístrate como vendedor",
    success: "¡Bienvenido!",
    error: "Error al iniciar sesión",
  },
  sellerSignup: {
    backHome: "Volver al inicio",
    createAccount: "Crear cuenta de vendedor",
    joinAs: "Únete a Meatbid como vendedor",
    signupTitle: "Registro de vendedor",
    fullName: "Nombre completo *",
    companyName: "Nombre de la empresa *",
    phoneNumber: "Número de teléfono *",
    email: "Correo electrónico *",
    password: "Contraseña *",
    creating: "Creando cuenta...",
    createButton: "Crear cuenta de vendedor",
    haveAccount: "¿Ya tienes cuenta?",
    signIn: "Inicia sesión",
    success: "¡Cuenta creada!",
    error: "Error al crear la cuenta",
    checkEmailTitle: "Revisa tu correo",
    checkEmailDescription:
      "Enviamos un enlace de verificación a {email}. Activa tu cuenta desde ese correo antes de iniciar sesión.",
    goToLogin: "Ir a iniciar sesión",
  },
  verifyEmail: {
    backHome: "Volver al inicio",
    loadingTitle: "Verificando correo",
    loadingDescription: "Estamos validando el enlace de verificación de tu cuenta.",
    successTitle: "Correo verificado",
    successDescription: "Tu cuenta ya está activa. Ahora puedes iniciar sesión.",
    errorTitle: "No se pudo verificar",
    errorDescription: "El enlace es inválido o expiró. Solicita un nuevo enlace de verificación.",
    goToLogin: "Ir a iniciar sesión",
  },
  adminLogin: {
    title: "Acceso de Administrador",
    email: "Correo Electrónico",
    password: "Contraseña",
    verifying: "Verificando...",
    signIn: "Ingresar",
    success: "Acceso concedido",
    error: "Error de acceso",
  },
  featuredCategories: {
    title: "Explorar Categorías",
    subtitle: "Cortes premium al mayoreo para tu negocio",
    products: "PRODUCTOS",
    items: {
      beef: "Cortes de Res",
      pork: "Selección de Cerdo",
      poultry: "Aves",
      lamb: "Cordero y Ovino",
      specialty: "Especialidades",
    },
  },
  featuredProducts: {
    title: "Productos Destacados",
    subtitle: "Productos en tendencia y de alta demanda",
    viewAll: "Ver Catálogo Completo",
  },
  seo: {
    defaultTitle: "MeatBid - Mercado de Carne por Volumen en México",
    defaultDesc:
      "La plataforma líder en México para la compra y venta de carne al por mayor. Conectamos procesadores y distribuidores con productos de alta calidad y precios competitivos.",
    homeTitle: "MeatBid | Comercialización de Carne a Gran Escala en México",
    homeDesc:
      "Venta de carne por volumen en México. Conectamos a los mejores proveedores con compradores industriales y comerciales. Calidad garantizada y logística eficiente.",
    catalogTitle: "Catálogo de Carne al Por Mayor | MeatBid México",
    catalogDesc:
      "Explore nuestra variedad de cortes de res, cerdo y pollo de alta calidad. Suministro constante para el sector industrial y restaurantero en México.",
    aboutTitle: "Sobre Nosotros | La Misión de MeatBid en México",
    aboutDesc:
      "Conozca MeatBid, la comercializadora que está revolucionando la industria cárnica mexicana a través de tecnología y transparencia.",
    contactTitle: "Contacto Ventas Mayoreo | MeatBid México",
    contactDesc:
      "Contacte a nuestros expertos para cotizaciones de carne por volumen. Servicio especializado para la industria cárnica mexicana.",
    keywords:
      "carne mexico, mayoreo carne, carne alto volumen, proveedores carne mexico, cortes de res mexico, comercializadora de carne, industria carnica",
  },
  notFound: {
    title: "404",
    message: "¡Oops! Página no encontrada",
    backHome: "Volver al Inicio",
  },
}

// Derive the shared type from the Spanish source so `en.ts` is always
// structurally identical and TypeScript will error on any missing key.
export type Locale = typeof es

